const NoDataPage = ({ img, text }) => {
    return (
        <>
            <div className="no_data_div">
                {img ? <img alt="" src={img} width='100px' /> : <h5>{text}</h5>}
            </div>
        </>
    )
}

export default NoDataPage;